import { useMonitor } from '../use-monitor';

export function useMonitorDiscardIssueFormLoad() {
  return useMonitor('discard-issue-form-load');
}
